//------------------------------------------------------------------------
// Modal windows
//------------------------------------------------------------------------
import Modal from "../lib/modals";

document.querySelectorAll(".Modal:not(.Explainer)").forEach(el => new Modal(el));
